import Selector from './selector/selector.component';

export const selectorTemplates = {
  [Selector.Templates.Selector]: Selector,
  [Selector.Templates.Tab]: Selector,
};

export const getSelectorTemplateById = id => selectorTemplates[id];
